import { OverlaySpinner, PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useAddEmployeesPageStore } from 'store/pages/enrollment/add-employees/pageStore';
import ConfirmationBlob from 'components/common/general/ConfirmationBlob';
import { TableManagementPanel } from './TableManagementPanel';
import { AddEmployeesTable } from '../../common/enrollment/add-employees/AddEmployeesTable';
import { CensusBypassSection } from './CensusBypassSection';
import { WrapperStyled } from './styles';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useAddEmployeesPageStore();
  const {
    stepCanComplete,
    isLoading,
    isEnrollmentLoading,
    isStepCompleted,
    showCensusBypassFeature,
    onUncompleteStep,
    onBack,
    onComplete,
    getEnrollmentPeriod,
  } = pageStore;

  useEffect(() => {
    void getEnrollmentPeriod();
  }, []);

  return (
    <>
      <PageHeader
        title={CARD_DATA.ADD_EMPLOYEES.title}
        subtitle={CARD_DATA.ADD_EMPLOYEES.text}
        subtitleMaxWidth="42rem"
        onBackButtonClick={onBack}
      />

      {isEnrollmentLoading ? (
        <WrapperStyled>
          <OverlaySpinner display />
        </WrapperStyled>
      ) : (
        <>
          {isStepCompleted && (
            <ConfirmationBlob
              title="This step has been completed"
              message={
                <>
                  The current step has been completed and saved. <br /> If you need to make changes, you can uncomplete
                  it to enable editing again.
                </>
              }
              btnText="Uncomplete Step"
              disabled={isLoading}
              onConfirm={onUncompleteStep}
            />
          )}
          <TableManagementPanel />
          <AddEmployeesTable pageStore={pageStore} isStepCompleted={isStepCompleted} />
          {!isStepCompleted && showCensusBypassFeature && <CensusBypassSection />}
        </>
      )}
      <PageFooter onBack={onBack} onComplete={onComplete} disableCompleteButton={!stepCanComplete || isStepCompleted} />
    </>
  );
});
